export default __webpack_public_path__ + "cec81cb32d918c275ce7757c39b754d0.png";